var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex-box"},[_c('div',{ref:"qrCodeUrl",staticClass:"qr-code"}),_c('div',[_vm._v("我的二维码,仅供推广用户使用")])])])}
var staticRenderFns = []

export { render, staticRenderFns }